import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper } from '@material-ui/core';
import formStyles from './styles';
import FileBase from 'react-file-base64';
import { useDispatch } from 'react-redux';
import { createPost, updatePost } from '../../actions/post';
import { useSelector } from 'react-redux';

const Form = ({ currentId, setCurrentId }) => {

    const classes = formStyles();

    const dispatch = useDispatch();

    const post = useSelector((state) => currentId ? state.posts.find((p) => p._id === currentId) : null);

    const [postData, setPostData] = useState({ title: '', message: '', tags: '', selectedFile: '' });

    const user = JSON.parse(localStorage.getItem('profile'));
    console.log(user);

    useEffect(() => {
        if (post) {
            setPostData(post)
        }
    // }, [currentId, post, user])
    }, [post])


    const handleSubmit = (e) => {
        e.preventDefault();

        if (currentId !==0 ) {
            dispatch(updatePost(currentId, { ...postData, name: user?.result?.name}));
        } else {
            dispatch(createPost({ ...postData, name: user?.result?.name }));
        }
        clear();
    }

    const clear = () => {
        setCurrentId(0);
        setPostData({ title: '', message: '', tags: '', selectedFile: '' });
    }

    // if user is not logged in
    if(!user?.result?.name) {
        return (
            <Paper className={classes.paper}>
                <Typography variant='h6' align='center'>
                    Please Sign In to create your own memories and like other's memories.
                </Typography>
            </Paper>
        )
    }

    return (
        <Paper className={classes.paper}>

            <form autoComplete='off' noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>

                <Typography variant='h6'>{currentId ? 'Edit' : 'Create'} a Memory</Typography>

                <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({ ...postData, title: e.target.value })} />

                <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({ ...postData, message: e.target.value })} />

                <TextField name="tags" variant="outlined" label="Tags (coma separated)" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags: e.target.value.split(',') })} />

                <div className={classes.fileInput}>
                    <FileBase type="file" multiple={false} onDone={({ base64 }) =>
                        setPostData({ ...postData, selectedFile: base64 })
                    } />
                </div>

                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>

                <Button variant="contained" color="secondary" size="large" onClick={clear} fullWidth>Clear</Button>

            </form>

        </Paper>
    )
}

export default Form;